import { IActivity } from '@sdk/contracts';

import { ActivityName, Wrapper } from './ActivityItem.styles';

import { Icon } from '@/components/Icon';
import { ACTIVITY_ICONS } from '@/constants';

type Props = {
  activity: IActivity;
};

export const ActivityItem: React.FC<Props> = ({ activity }) => (
  <Wrapper>
    <Icon i={ACTIVITY_ICONS[activity.type]} />
    <ActivityName>{activity.name}</ActivityName>
  </Wrapper>
);
